$(document).ready(function () {
  $('.marken-menu-item').hover(function () {
    const newImg = $(this).data('hover');
    if (newImg) {
      $('#marken-banner-img').attr('src', newImg);
    }
  });

    $('.marken-menu-item').click(function () {
    const targetId = $(this).data('anchor');
    const $target = $('#' + targetId);
    if ($target.length) {
      $('html, body').animate(
        {
          scrollTop: $target.offset().top - 50
        },
        600
      );
    }
  });
  
 $('.scroll-marken li a').click(function (e) {
  e.preventDefault(); 
  const targetId = $(this).attr('href').replace('#', '');
  const $target = $('#' + targetId);
  if ($target.length) {
    $('html, body').animate(
      {
        scrollTop: $target.offset().top 
      },
      600
    );
  }
});
});
